import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { find } from 'lodash';
import { useAdsContext } from '../../contexts/AdsContext';
import AdSlot from '../AdSlot';
const AdUnderstitial = () => {
    const { adsEnabled, adSlots } = useAdsContext();
    const understitial = find(adSlots, { name: 'understitial' });
    return (adsEnabled &&
        understitial && (_jsx(Box, { height: "60vh", position: "relative", children: _jsx(Box, { position: "absolute", top: "0", left: "0", width: "100%", height: "100%", clipPath: "polygon(0 0,100% 0,100% 100%,0 100%)", children: _jsx(Box, { position: "fixed", top: "56px", right: "0", bottom: "0", left: "0", zIndex: "zIndex.none", margin: "auto", transform: "translateZ(0)", width: understitial.placeholderWidth, height: understitial.placeholderHeight, children: _jsx(AdSlot, { slot: "understitial" }) }) }) })));
};
export default AdUnderstitial;
